import type React from 'react';
import type { FC } from 'react';
import { Link, matchPath, useLocation } from 'react-router';
import { useIsClientOutdated } from '../../../../../contexts/OutdatedClientContext';
import mndUrl, { SubDomain } from '../../../../../lib/mndUrl';

const wrongSubDomain = mndUrl(SubDomain.Publish, '') !== window.location.origin;

const NavigationLink: FC<{
  href: string;
  onClick?: () => void;
  newTab?: boolean;
  'data-testid'?: string;
  activeUrl?: string | string[];
  exactMatch?: boolean;
  children?: React.ReactNode;
}> = ({ href, onClick, children, newTab, activeUrl, exactMatch, 'data-testid': dataTestId }) => {
  const location = useLocation();
  const activeUrls = Array.isArray(activeUrl) ? activeUrl : activeUrl ? [activeUrl] : [href];
  const match = activeUrls.find(url =>
    matchPath({ path: url, end: !!exactMatch }, location.pathname),
  );
  const absoluteUrl = href.startsWith('http://') || href.startsWith('https://');
  href = wrongSubDomain && !absoluteUrl ? mndUrl(SubDomain.Publish, href) : href;

  const outdatedClient = useIsClientOutdated();
  const commonProps = {
    onClick: () => onClick?.(),
    className: match ? 'navigation-link-active' : undefined,
    children,
  };

  if (absoluteUrl || newTab || wrongSubDomain) {
    const blank = newTab
      ? {
          target: '_blank',
          rel: 'noopener noreferrer',
        }
      : {};
    return <a href={href} {...commonProps} {...blank} />;
  }

  if (outdatedClient) {
    return <a href={href} {...commonProps} data-testid={dataTestId} />;
  }
  return <Link to={href} {...commonProps} data-testid={dataTestId} />;
};

export default NavigationLink;
